import React, { useState, useEffect, useRef, useContext } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Router, Routes, useLocation } from 'react-router-dom';
import AppTopbar from './layouts/AppTopbar';
import AppFooter from './layouts/AppFooter';
import AppMenu from './layouts/AppMenu';
import Dashboard from './pages/dashboard/Dashboard';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import AuthContext from './context/authContext';
import { CollegeManagement } from './pages/college-management/CollegeManagement';
import { PciApproval } from './pages/college-management/PciApproval';
import { AdmittedList } from './pages/college-management/AdmittedList';
import { PassoutList } from './pages/college-management/PassoutList';
import { FreshApplication } from './pages/applications/FreshApplication/FreshApplication';
import { ViewAllBookedAppointment } from './pages/applications/ViewAllBookedAppointment/ViewAllBookedAppointment';
import { ApplicationViewForm } from './pages/applications/ViewApplication/ApplicationViewForm';
import { ViewDocument } from './pages/applications/ViewDocument/ViewDocument';
import { VerificationList } from './pages/applications/ViewApplication/VerificationList';
import { FreshApplicationOther } from './pages/applications/FreshApplication/FreshApplicationOther';
import { FreshApplicationTranferIn } from './pages/applications/FreshApplication/FreshApplicationTranferIn';
import { FreshApplicationDamanAndDiu } from './pages/applications/FreshApplication/FreshApplicationDamanAndDiu';
import { EligibleApplicationList } from './pages/applications/FreshApplication/EligibleApplicationList';
import { EligibleViewForm } from './pages/applications/ViewApplication/EligibleViewForm';
import { ViewEligibleDocument } from './pages/applications/ViewDocument/ViewEligibleDocument';
import { EligibleApplicationOtherList } from './pages/applications/FreshApplication/EligibleApplicationOtherList';
import { RenewApplication } from './pages/applications/RenewReentryApplication/RenewApplication';
import { ViewOtherDocument } from './pages/applications/ViewDocument/ViewOtherDocument';
import { ReEntryApplication } from './pages/applications/RenewReentryApplication/ReEntryApplication';
import { Electoral } from './pages/applications/ElectionApplication/Electoral';
import { ElectionDeposit } from './pages/applications/ElectionApplication/ElectionDeposit';
import { NominationFormFees } from './pages/applications/ElectionApplication/NominationFormFees';
import { AddressChange } from './pages/applications/OtherApplication/AddressChange';
import { NameChange } from './pages/applications/OtherApplication/NameChange';
import { GoodStanding } from './pages/applications/OtherApplication/GoodStanding';
import { DuplicateCertificate } from './pages/applications/OtherApplication/DuplicateCertificate';
import { DegreeAddition } from './pages/applications/OtherApplication/DegreeAddition';
import { Penalty } from './pages/applications/OtherApplication/Penalty';
import { RegistrationCancellation } from './pages/applications/OtherApplication/RegistrationCancellation';
import { PermanentRegCancellation } from './pages/applications/OtherApplication/PermanentRegCancellation';
import { ProToOrg } from './pages/applications/OtherApplication/ProToOrg';
import { SearchByName } from './pages/applications/OtherApplication/SearchByName';
import { OnlineRefresherCourseList } from './pages/RefresherCourse/OnlineRefresherCourse/OnlineRefresherCourseList';
import { ViewRefresherCourseCandidates } from './pages/RefresherCourse/OnlineRefresherCourse/ViewRefresherCourseCandidates';
import { ViewRefresherCourseCertification } from './pages/RefresherCourse/OnlineRefresherCourse/ViewRefresherCourseCertification';
import { OfflineRefresherCourseList } from './pages/RefresherCourse/OfflineRefresherCourse/OfflineRefresherCourseList';
import { ViewOfflineRefresherCourseCandidates } from './pages/RefresherCourse/OfflineRefresherCourse/ViewOfflineRefresherCourseCandidates';
import { ViewOfflineRefresherCourseCertification } from './pages/RefresherCourse/OfflineRefresherCourse/ViewOfflineRefresherCourseCertification';
import { AddUpdateOnlineRefresherCourse } from './pages/RefresherCourse/OnlineRefresherCourse/AddUpdateOnlineRefresherCourse';
import { UserManagement } from './pages/UserManagement/UserManagement';
import { BookAppointments } from './pages/BookAppointments/BookAppointments';
import { AppointmentList } from './pages/BookAppointments/AppointmentList';
import { UserAppointmentList } from './pages/BookAppointments/UserAppointmentList';
import { BankEntry } from './pages/Account/BankEntry/BankEntry';
import { AddBankEntry } from './pages/Account/BankEntry/AddBankEntry';
import { CashEntry } from './pages/Account/CashEntry/CashEntry';
import { AddCashEntry } from './pages/Account/CashEntry/AddCashEntry';
import { JVEntry } from './pages/Account/JVEntry/JVEntry';
import { AddJVEntry } from './pages/Account/JVEntry/AddJVEntry';
import { AccountMaster } from './pages/Master/AccountMaster/AccountMaster';
import { AccountGroup } from './pages/Master/AccountGroup/AccountGroup';
import { Billing } from './pages/Billing/Billing';
import { AddUpdateOfflineRefresherCourse } from './pages/RefresherCourse/OfflineRefresherCourse/AddUpdateOfflineRefresherCourse';
import { ProvisionalCertificate } from './pages/Certificates/ProvisionalCertificate/ProvisionalCertificate';
import { ProvisionalCertificateList } from './pages/Certificates/ProvisionalCertificate/ProvisionalCertificateList';
import { OriginalCertificate } from './pages/Certificates/OriginalCertificate/OriginalCertificate';
import { OriginalCertificateList } from './pages/Certificates/OriginalCertificate/OriginalCertificateList';
import { RemainingOriginalCertificateList } from './pages/Certificates/OriginalCertificate/RemainingOriginalCertificateList';
import { DuplicateCertificateList } from './pages/Certificates/DuplicateCertificate/DuplicateCertificateList';
import { AdditionalCertificate } from './pages/Certificates/AdditionalCertificate/AdditionalCertificate';
import { GoodStandingCertificate } from './pages/Certificates/GoodStandingCertificate/GoodStandingCertificate';
import { GoodStandingCertificateList } from './pages/Certificates/GoodStandingCertificate/GoodStandingCertificateList';
import { RegistrationDateUpdate } from './pages/Certificates/RegistrationDateUpdate/RegistrationDateUpdate';
import { InwardRegister } from './pages/InOutRegister/InwardRegister/InwardRegister';
import { InwardRegisterList } from './pages/InOutRegister/InwardRegister/InwardRegisterList';
import { OutwardRegister } from './pages/InOutRegister/OutwardRegister/OutwardRegister';
import { OutwardRegisterList } from './pages/InOutRegister/OutwardRegister/OutwardRegisterList';
import { DepartmentList } from './pages/JobPortal/DepartmentList';
import { StudentList } from './pages/JobPortal/StudentList';
import { JobList } from './pages/JobPortal/JobList';
import { ApplicationBillMaster } from './pages/Master/ApplicationMaster/ApplicationBillMaster/ApplicationBillMaster';
import { ApplicationMaster } from './pages/Master/ApplicationMaster/ApplicationMaster/ApplicationMaster';
import { DocumentMaster } from './pages/Master/ApplicationMaster/DocumentMaster/DocumentMaster';
import { BoardMaster } from './pages/Master/BoardMaster/BoardMaster';
import { ApprovalMasterList } from './pages/Master/Approval/ApprovalMasterList';
import { AddApprovalMasetr } from './pages/Master/Approval/AddApprovalMaster';
import { CollegeEntry } from './pages/Master/CollegeEntry/CollegeEntry';
import { AllCollegesList } from './pages/Master/CollegeEntry/CollegeList';
import { CouncilMaster } from './pages/Master/CouncilMaster/CouncilMaster';
import { ExamAuthority } from './pages/Master/ExamAuthority/ExamAuthority';
import { HospitalMaster } from './pages/Master/HospitalMaster/HospitalMaster';
import { AllHospitalList } from './pages/Master/HospitalMaster/HospitalMasterList';
import { OtherMaster } from './pages/Master/OtherMaster/OtherMaster';
import { UniversityMaster } from './pages/Master/UniversityMaster/UniversityMasret';
import { UserUpdate } from './pages/Master/UserUpdate/UserUpdate';
import { RHUSLetter } from './pages/Letters/VerificationLetters/RHUSLetter/RHUSLetter';
import { NIOSLETTER, NOCLETTER, USER_DATA_BY_ID } from './config/ApiConstant';
import { NIOSLetter } from './pages/Letters/VerificationLetters/NIOSLetter/NIOSLetter';
import { UniversityLetter } from './pages/Letters/VerificationLetters/UniversityLetter/UniversityLetter';
import { BoardLetter } from './pages/Letters/VerificationLetters/BoardLetter/BoardLetter';
import { CollegeLetter } from './pages/Letters/VerificationLetters/CollegeLetter/CollegeLetter';
import { SchoolLetter } from './pages/Letters/VerificationLetters/SchoolLetter/SchoolLetter';
import { RegistrationCancellationLetter } from './pages/Letters/CancellationLetters/RegistrationCancellation/RegistrationCancellationLeter';
import { ApplicationCancellationLetter } from './pages/Letters/CancellationLetters/ApplicationCancellation/ApplicationCancellationLetter';
import { WarningLetter } from './pages/Letters/CancellationLetters/WarningLetter/WarningLetter';
import { ReminderToCollege } from './pages/Letters/ReminderLetters/ReminderToCollege';
import { ReminderToSchool } from './pages/Letters/ReminderLetters/ReminderToSchool';
import { ReminderToCouncil } from './pages/Letters/ReminderLetters/ReminderToCouncil';
import { ReminderToHospital } from './pages/Letters/ReminderLetters/ReminderToHospital';
import { ReminderToMedical } from './pages/Letters/ReminderLetters/ReminderToMedical';
import { ReminderToUniversity } from './pages/Letters/ReminderLetters/ReminderToUniversity';
import { ReminderToBoard } from './pages/Letters/ReminderLetters/ReminderToBoard';
import { ReminderToNIOS } from './pages/Letters/ReminderLetters/ReminderToNIOS';
import { ReminderToRUHS } from './pages/Letters/ReminderLetters/ReminderToRUHS';
import { NOCLetter } from './pages/Letters/OtherLetters/NOCLetter';
import { TransferInLetter } from './pages/Letters/OtherLetters/TransferInLetter';
import { PracticalTraining } from './pages/Letters/OtherLetters/PracticalTrainingLetter';
import { ApplicationRegisterReport } from './pages/Reports/Applicationregister/ApplicationRegisterReport';
import { FreshRegistrationScrutiny } from './pages/Scrutiny/FreshRegistrationScrutiny/FreshRegistrationScrutiny';
import { dynamicMenuSections, setScrutinyActiveTab, updateFirstAccessiblePath } from './appconfig/AppHelper';
import { FreshRegistrationScrutinySteps } from './pages/Scrutiny/FreshRegistrationScrutiny/FreshRegistrationScrutinySteps';
import { ScrutinyVerificationList } from './pages/Scrutiny/VerificationList/ScrutinyVerificationList';
import { OtherStateScrutiny } from './pages/Scrutiny/OtherStateScrutiny/OtherStateScrutiny';
import { OtherStateScrutinySteps } from './pages/Scrutiny/OtherStateScrutiny/OtherStateScrutinySteps';
import { ViewScrutinyDocument } from './pages/Scrutiny/ViewDocuments/ViewScrutinyDocument';
import { TransferToGujaratScrutiny } from './pages/Scrutiny/TransferToGujaratScrutiny/TransferToGujaratScrutiny';
import { TrasnferToGujaratScrutinySteps } from './pages/Scrutiny/TransferToGujaratScrutiny/TransferToGujaratScrutinySteps';
import { TransferToDDDNHScrutiny } from './pages/Scrutiny/TransferToDDDNHScrutiny/TransferToDDDNHScrutiny';
import { TrasnferToDDDNHScrutinySteps } from './pages/Scrutiny/TransferToDDDNHScrutiny/TransferToDDDNHScrutinySteps';
import { DegreeAdditionScrutiny } from './pages/Scrutiny/DegreeAdditionScrutiny/DegreeAdditionScrutiny';
import { DegreeAdditionScrutinySteps } from './pages/Scrutiny/DegreeAdditionScrutiny/DegreeAddititonScrutinySteps';
import { ViewOtherScrutinyDocument } from './pages/Scrutiny/ViewDocuments/ViewOtherScrutinyDocument';
import { FeeRegisterReport } from './pages/Reports/FeeRegister/FeeRegister';
import { DegreeDetails } from './pages/Reports/DegreeDetails/DegreeDetails';
import { GNumberWiseReport } from './pages/Reports/GNoWiseReport/GNoWiseReport';
import { ReceiptDownload } from './pages/Reports/ReceiptDownload/ReceiptDownload';
import { RegistrationValidation } from './pages/Reports/RegistrationValidation/RegistrationValidation';
import { ApplicationDetail } from './pages/Reports/ApplicationDetail/ApplicationDetail';
import { RegistrationCancellations } from './pages/Reports/RegistrationCancellation/RegistrationCancellation';
import { DDRegisterReport } from './pages/Reports/DDRegsiter/DDRegisterReports';
import { ProvOrgCertificateReport } from './pages/Reports/ProvOrgCertificate/ProvOrgCertificate';
import { CollegeWiseRegisterReport } from './pages/Reports/CollegeWiseRegister/CollegeWiseRegisterReport';
import { GovernmentReport } from './pages/Reports/GovernmentReport/GovernmentReport';
import { PCIRegisterReport } from './pages/Reports/PCIRegister/PCIRegister';
import { RecordRegisterReport } from './pages/Reports/RecoredRegister/RecordRegister';
import { ElectrolRegisterReport } from './pages/Reports/ElectrolRegister/ElectrolRegister';
import { StaticsReport } from './pages/Reports/StatisticsReport/StatisticsReport';
import { InOutRegisterReport } from './pages/Reports/InOutRegister/InOutRegisterReport';
import { FinancialReports } from './pages/FinancialReport/FinancialReort';
import { AccountLedgerReport } from './pages/FinancialReport/AccountLedger/AccountLedgerReport';
import { CashBookDetailsReport } from './pages/FinancialReport/AccountLedger/CashBookDetailReport';
import { BankBookDetailReport } from './pages/FinancialReport/BankBookDetail/BankBookDetail';
import { JvBookDetailsReport } from './pages/FinancialReport/JvBookDetail/JvBookDetail';
import { TrialBalanceReport } from './pages/FinancialReport/TrialBalance/TrialBalance';
import { ProfitLossReport } from './pages/FinancialReport/ProfitLoss/ProfitLossReport';
import { Banner } from './pages/FrontWebsite/Banner';
import { LatestUpdate } from './pages/FrontWebsite/LatestUpadate';
import { Notice } from './pages/FrontWebsite/Notice';
import { RefresherCourse } from './pages/FrontWebsite/RefresherCourse';
import { Inquiry } from './pages/FrontWebsite/Inquiry';
import { Gallary } from './pages/FrontWebsite/Gallary';
import { Reports } from './pages/Reports/Reports';
import { RoleManagement } from './pages/RoleManagement/RoleManagement';
import { AddRole } from './pages/RoleManagement/AddRole';
import { UserWiseMenu } from './pages/RoleManagement/UserWiseMenu';
import { getSpecificDetailsById } from './service/ProductService';
import { FreshApplicationRegisterReport } from './pages/Reports/FreshApplicationRegister/FreshApplicationRegister';
import { ReEntryScrutiny } from './pages/Scrutiny/ReEntryScrutiny/ReEnyryScrutiy';
import { ReEntryScrutinySteps } from './pages/Scrutiny/ReEntryScrutiny/ReEntryScrutinySteps';
import { AddDocument } from './pages/Master/ApplicationMaster/DocumentMaster/AddDocumentMaster';
import Loader from './components/Loadeer/Loader';
import { UserHistory } from './pages/UserHistory/UserHistory';
import { AdmitDetails } from './pages/college-management/AdmitDetails';
import { PassoutDetail } from './pages/college-management/PassoutDetail';
import { PendingPciApprovalList } from './pages/college-management/PendingPciApprovalList';
import { ViewCertificationList } from './pages/RefresherCourse/OnlineRefresherCourse/ViewCertificationList';
import { WrongAffidavitLetter } from './pages/Letters/CancellationLetters/WrongAffidavit/WrongAffidavit';
import { FalseAndFakeLetter } from './pages/Letters/CancellationLetters/False&Fake/FalseAndFake';
import { GujaratOtherCouncils } from './pages/Letters/VerificationLetters/GujaratOtherCouncils/GujaratOtherCouncils';
import { DataFlow } from './pages/Letters/DataFlowLetter/DataFlow/DataFlow';
import { SubmissionLetter } from './pages/Letters/CancellationLetters/SubmissionLetter/SubmissionLetter';
import { PendingAdmittedList } from './pages/college-management/PendingAdmittedList';
import { PendingPassoutList } from './pages/college-management/PendingPassoutList';
import { ViewOfflineCertificationList } from './pages/RefresherCourse/OfflineRefresherCourse/ViewOfflineCertificationList';
import { PenaltyJanVishwas } from './pages/applications/OtherApplication/PenaltyJanVishwas';

const App = (props: any) => {
    const [menuMode] = useState('slim');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
    const copyTooltipRef = useRef<any>();
    const location = useLocation();
    const [assignedActions, setAssignedActions] = useState<any>([]);
    const roleName = localStorage.getItem('role');

    const [scrutinyTab, setScrutinyTab] = useState<any>(null);
    const [dyamicUrl, setDynaminUrl] = useState<any>([]);
    const [assignedMenuItems, setAssignedMenuItems] = useState([]);

    //  const [assignedActions, setAssignedActions] = useState<any[]>([]);
    const [menuWithAccess, setMenuWithAccess] = useState<any[]>([]);

    const getFirstAccessibleSubItem = (items: any[], actions: any[]): string | null => {
        for (const item of items) {
            const itemLevelAction = actions.find((a) => a.menu === item.label || a.menu === item.parentLabel);

            if (item.items && Array.isArray(item.items)) {
                for (const subItem of item.items) {
                    const subLevelAction = actions.find((a) => a.menu === subItem.label || a.menu === item.label);
                    if (typeof subLevelAction === 'object' && subLevelAction[subItem.label] === 1) {
                        return subItem.to;
                    }

                    // ✅ Handle 3rd-level nested items like "RUHS Verification Letter"
                    if (subItem.items && Array.isArray(subItem.items)) {
                        for (const nested of subItem.items) {
                            const nestedAction = actions.find((a) => a.menu === nested.label || a.menu === subItem.label);
                            if (typeof nestedAction === 'object' && nestedAction[nested.label] === 1) {
                                return nested.to;
                            }
                        }
                    }
                }
            } else if (typeof itemLevelAction === 'object' && itemLevelAction[item.label] === 1) {
                return item.to;
            }
        }
        return null;
    };

    const mapMenuToAccessiblePaths = (menu: any[], actions: any[], parentLabel: string | null = null): any[] => {
        return menu
            .map((item) => {
                const newItem = { ...item, parentLabel };
                const directAction = actions.find((a) => a.menu === item.label);

                if (!item.items && directAction) {
                    return newItem;
                }

                if (item.items && Array.isArray(item.items)) {
                    const filteredSubItems = mapMenuToAccessiblePaths(item.items, actions, item.label);

                    const hasSecondLevelAccess = filteredSubItems.some((subItem: any) => {
                        const parentAction = actions.find((a) => a.menu === item.label);
                        return parentAction && parentAction[subItem.label] === 1;
                    });

                    const hasThirdLevelAccess = item.items.some((subItem: any) =>
                        subItem.items?.some((nested: any) => {
                            const nestedAction = actions.find((a) => a.menu === subItem.label || a.menu === item.label);
                            return nestedAction && nestedAction[nested.label] === 1;
                        })
                    );

                    const hasDirectMenuAccess = actions.some((a) => a.menu === item.label);

                    if (filteredSubItems.length > 0 || hasSecondLevelAccess || hasThirdLevelAccess || hasDirectMenuAccess) {
                        const skipOverride = ['Reports', 'Financial Reports'].includes(item.label);
                        return {
                            ...item,
                            to: skipOverride ? item.to : getFirstAccessibleSubItem([{ ...item, items: filteredSubItems, parentLabel: item.label }], actions) || item.to,
                            items: filteredSubItems
                        };
                    }
                } else {
                    const subAction = actions.find((a) => a.menu === parentLabel);
                    if (subAction && subAction[item.label] === 1) {
                        return newItem;
                    }
                }

                return null;
            })
            .filter((item) => item !== null);
    };

    useEffect(() => {
        // Get Role
        getRole();
        if (roleName && !window.cn(roleName)) {
            let activeTab = setScrutinyActiveTab(roleName);
            if (!window.cn(activeTab)) {
                setScrutinyTab(activeTab);
            }
        }
    }, [roleName, scrutinyTab]);

    // Edit role
    const getRole = async () => {
        const response = await getSpecificDetailsById(USER_DATA_BY_ID, localStorage.getItem('user'));

        if (response?.assigned_menu) {
            // const parsedActions = JSON.parse(response?.assigned_actions || '[]');
            // setDynaminUrl(parsedActions);
            // let tempAssignedActions = response.assigned_menu?.split(',');
            // setAssignedActions(tempAssignedActions);
            // assignedMenu(tempAssignedActions);
            // if (!response?.assigned_menu) return;
            // const assignedLabels = response.assigned_menu.split(',').map((s: string) => s.trim());
            // const filteredMenu: any = filterMenuByAssignedLabels(menu, assignedLabels);
            // setAssignedMenuItems(filteredMenu);

            const parsedActions = JSON.parse(response?.assigned_actions || '[]');
            setAssignedActions(parsedActions);

            const transformed = mapMenuToAccessiblePaths(menu, parsedActions);

            setMenuWithAccess(transformed);
        }
    };

    const menu = [
        {
            label: 'Dashboard',
            icon: 'pi pi-home',
            to: '/dashboard'
        },
        {
            label: 'Permission',
            icon: 'pi pi-spin pi-cog',
            to: '/app/permission/role-management',

            items: [
                { label: 'RoleWise Menu Management', to: '/app/permission/role-management' },
                { label: 'UserWise Menu Management', to: '/app/permission/user-management' }
            ]
        },
        {
            label: 'College Management',
            icon: 'fas fa-graduation-cap',
            to: '/app/college-management',
            items: [
                { label: 'College Management', to: '/app/college-management' },
                { label: 'PCI Approval', to: '/app/pci-approval' },
                { label: 'Admitted List', to: '/app/admitted-list' },
                { label: 'Passout List', to: '/app/passout-list' }
            ]
        },

        {
            label: 'Refresher Course',
            icon: 'fas fa-chalkboard-teacher',
            to: '/app/refresher-course-list',
            items: [
                { label: 'Online Refresher Course', to: '/app/refresher-course-list' },
                { label: 'Offline Refresher Course', to: '/app/offline-refresher-course-list' }
            ]
        },
        {
            label: 'User Management',
            icon: 'pi pi-user',
            to: '/app/user-management'
        },
        {
            label: 'Applications',
            icon: 'fas fa-window-maximize',
            to: '/app/application/fresh-registration-list',
            items: [
                {
                    label: 'Fresh Application',
                    to: '/app/application/fresh-registration-list',
                    items: [
                        { label: 'Fresh Registration', to: '/app/application/fresh-registration-list' },
                        { label: 'Fresh Registration Other', to: '/app/application/fresh-registration-other-list' },
                        { label: 'Fresh Registration (Transfer To Gujarat)', to: '/app/application/fresh-registration-transfer-list' },
                        { label: 'Transfer DD/DNH', to: '/app/application/fresh-registration-transfer-list-diu-daman/QWxs' },
                        { label: 'Eligible Application (Maharashtra State)', to: '/app/application/eliglible-application-list' },
                        { label: 'Eligible Application (Other)', to: '/app/application/eliglible-application-other-list' }
                    ]
                },
                {
                    label: 'Renew/Re-Entry Application',
                    to: '/app/application/renew-application',
                    items: [
                        { label: 'Renew Application', to: '/app/application/renew-application' },
                        { label: 'Re-Entry Application', to: '/app/application/re-entry' }
                    ]
                },
                {
                    label: 'Election Application',
                    to: '/app/application/electoral',
                    items: [
                        { label: 'Electoral Roll Fees Application', to: '/app/application/electoral' },
                        { label: 'Election Deposit Application', to: '/app/application/election-deposit' },
                        { label: 'Nomination Form Fees', to: '/app/application/nomination-fees-form' }
                    ]
                },
                {
                    label: 'Other Application',
                    to: '/app/application/address-change',
                    items: [
                        { label: 'Address Change', to: '/app/application/address-change' },
                        { label: 'Name Change', to: '/app/application/name-change' },
                        { label: 'Good Standing Application', to: '/app/application/goodstanding-application-list' },
                        { label: 'Duplicate Cerificate', to: '/app/application/duplicate-certificate-application-list' },
                        { label: 'Registration Cancellation', to: '/app/application/registration-cancellation' },
                        { label: 'Degree Additional', to: '/app/application/degree-addition' },
                        { label: 'Provisional To Original', to: '/app/application/pro-to-org-application' },
                        { label: 'Penalty', to: '/app/application/penlty' },
                        { label: 'Penalty Under Jan Vishwas', to: '/app/application/penalty-jan-vishwas' },
                        { label: 'Search', to: '/app/application/search' }
                    ]
                }
            ]
        },

        {
            label: 'Book Appointment',
            icon: 'pi pi-calendar',
            to: '/app/book-appointment',
            items: [
                { label: 'Appointment Slots', to: '/app/book-appointment' },
                { label: 'Appointment List', to: '/app/appointment-list' }
            ]
        },
        {
            label: 'Account',
            icon: 'fas fa-user',
            to: '/app/account/bank-entry',
            items: [
                { label: 'Bank Entry', to: '/app/account/bank-entry' },
                { label: 'Cash Entry', to: '/app/account/cash-entry' },
                { label: 'JV Entry', to: '/app/account/jv-entry-list' },
                { label: 'Account Master', to: '/app/account-master' },
                { label: 'Account Group', to: '/app/account-group' }
            ]
        },
        {
            label: 'Billing',
            icon: 'fas fa-receipt',
            to: '/app/billing/billing'
        },
        {
            label: 'Certificates',
            icon: 'fas fa-file-signature',
            to: '/app/certificate/provisional-certificate',
            items: [
                { label: 'Provisional Certificate', to: '/app/certificate/provisional-certificate' },
                { label: 'Original Certificate', to: '/app/certificate/original-certificate' },
                { label: 'Duplicate Certificate', to: '/app/certificate/duplicate-certificate' },
                { label: 'Additional Certificate', to: '/app/certificate/additional-certificate' },
                { label: 'Good Standing Certificate', to: '/app/certificate/goodstanding-certificate' },
                { label: 'Registration Date Update', to: '/app/certificate/registration-date-update' }
            ]
        },
        {
            label: 'Master',
            icon: 'fas fa-medal',
            to: '/app/application-bill-master',
            items: [
                {
                    label: 'Application Bill Master',
                    to: '/app/application-bill-master'
                },
                {
                    label: 'Application Master',
                    to: '/app/application-master'
                },
                { label: 'Approval Master', to: '/app/approval' },
                { label: 'Board Master', to: '/app/board-master' },
                { label: 'College Entry', to: '/app/college-entry' },
                { label: 'Council Master', to: '/app/other-master' },
                { label: 'Document Master', to: '/app/document-master' },
                { label: 'Exam Authority', to: '/app/exam-authority' },
                { label: 'Hospital Master', to: '/app/hospital-master' },
                { label: 'Other Master', to: '/app/other-master' },
                { label: 'University Master', to: '/app/university-master' },
                { label: 'User Bind / Email Update / Password Update', to: '/app/user-update' }
            ]
        },
        {
            label: 'In-Out Register',
            icon: 'fas fa-registered',
            to: '/app/in-out/add-inward-registration',
            items: [
                { label: 'InWard Register', to: '/app/in-out/add-inward-registration' },
                { label: 'OutWard Register', to: '/app/in-out/add-outward-registration' }
            ]
        },
        {
            label: 'Job Portal',
            icon: 'fas fa-book',
            to: '/app/job-portal/department-list',
            items: [
                { label: 'Department List', to: '/app/job-portal/department-list' },
                { label: 'Student List', to: '/app/job-portal/student-list' },
                { label: 'Job List', to: '/app/job-portal/job-list' }
            ]
        },
        {
            label: 'Letters',
            icon: 'fas fa-envelope-open-text',
            to: '/app/letters/ruhs-letter',
            items: [
                {
                    label: 'Verification Letters',
                    to: '/app/letters/ruhs-letter',
                    items: [
                        { label: 'RUHS Verification Letters', to: '/app/letters/ruhs-letter' },
                        { label: 'NIOS Verification Letters', to: '/app/letters/nios-letter' },
                        { label: 'University Verification Letters', to: '/app/letters/verification-university' },
                        { label: 'Board Verification Letters', to: '/app/letters/verification-board' },
                        { label: 'College Verification Letters', to: '/app/letters/verification-college' },
                        { label: 'School Verification Letters', to: '/app/letters/verification-school' }
                    ]
                },
                {
                    label: 'Cancellation Letters',
                    to: '/app/letters/register-cancellation',
                    items: [
                        { label: 'Registration Cancellation', to: '/app/letters/register-cancellation' },
                        { label: 'Application Cancellation', to: '/app/letters/application-cancellation' }
                    ]
                },
                {
                    label: 'Reminder Letters',
                    to: '/app/letters/reminder-college-letter',
                    items: [
                        { label: 'Reminder To College', to: '/app/letters/reminder-college-letter' },
                        { label: 'Reminder To School', to: '/app/letters/reminder-school-letter' },
                        { label: 'Reminder To Council', to: '/app/letters/reminder-council' },
                        { label: 'Reminder To Hospital', to: '/app/letters/reminder-hospital' },
                        { label: 'Reminder To Medical', to: '/app/letters/reminder-medical' },
                        { label: 'Reminder To University', to: '/app/letters/reminder-university' },
                        { label: 'Reminder To Board', to: '/app/letters/reminder-board' },
                        { label: 'Reminder To NIOS', to: '/app/letters/reminder-nios' },
                        { label: 'Reminder To RUHS', to: '/app/letters/reminder-ruhs' }
                    ]
                },
                {
                    label: 'Other Letters',
                    to: '/app/letters/noc-letter',
                    items: [
                        { label: 'NOC Letter', to: '/app/letters/noc-letter' },
                        { label: 'Transfer In', to: '/app/letters/transferin' },
                        { label: 'Letters To Hospital', to: '/app/letters/practical-training' }
                    ]
                },
                {
                    label: 'Data Flow',
                    to: '/app/letters/data-flow',
                    items: [{ label: 'Data Flow', to: '/app/letters/data-flow' }]
                }
            ]
        },
        {
            label: 'Scrutiny',
            icon: 'fas fa-info',
            to: '',
            items: [
                { label: 'Scrutiny (Gujarat)', to: `/app/scrutiny/fresh-registration-scrutiny/${window.btoa(scrutinyTab)}` },
                { label: 'Scrutiny (Other State)', to: `/app/scrutiny/other-state-scrutiny/${window.btoa(scrutinyTab)}` },
                { label: 'Scrutiny (Transfer To Gujarat)', to: `/app/scrutiny/transfer-to-gujarat-scrutiny/${window.btoa(scrutinyTab)}` },
                { label: 'Scrutiny (Transfer DD/DNH)', to: `/app/scrutiny/transfer-to-dd-dnh-scrutiny/${window.btoa(scrutinyTab)}` },
                { label: 'Scrutiny (Degree Additional)', to: `/app/scrutiny/degree-addition-scrutiny/${window.btoa(scrutinyTab)}` },
                { label: 'Scrutiny (Re Entry)', to: `/app/scrutiny/re-entry-scrutiny/${window.btoa(scrutinyTab)}` }
            ]
        },
        {
            label: 'Reports',
            icon: 'fas fa-file-alt',
            to: '/app/reports'
        },

        {
            label: 'Financial Reports',
            icon: 'fas fa-wallet',
            to: '/app/financial-reports'
        },
        {
            label: 'Front Website',
            icon: 'fas fa-desktop',
            to: '/app/banner-image',
            items: [
                { label: 'Banner Image', to: '/app/banner-image' },
                { label: 'Announcement & Notifications', to: '/app/latest-update' },
                { label: 'Circular/Notice', to: '/app/notice' },
                { label: 'Refresher Course', to: '/app/refresher-course' },
                { label: 'Gallery', to: '/app/gallery' },
                { label: 'Inquiry', to: '/app/inquiry' }
            ]
        }
    ];

    // Make roles menu
    const assignedMenu = (assignedActions: any) => {
        let newMenu: any = menu;
        //check for assigned roles
        for (let i = 0; i < assignedActions.length; i++) {
            for (let j = 0; j < newMenu.length; j++) {
                //check if inner roles exists
                if (newMenu[j].hasOwnProperty('items')) {
                    let items: any = newMenu[j].items;
                    //check for inner roles
                    for (let k = 0; k < items.length; k++) {
                        //if role is assigned change status to 1
                        if (items[k].label == assignedActions[i]) {
                            items[k].status = '1';
                        }
                    }
                } else {
                    //if role is assigned change status to 1
                    if (newMenu[j].label == assignedActions[i]) {
                        newMenu[j]['status'] = '1';
                    }
                }
            }
        }

        //Create new array for assisgned roles to display in sidebar
        let newAssignedRoles = [];
        for (let j = 0; j < newMenu.length; j++) {
            if (newMenu[j].hasOwnProperty('items')) {
                //check for inner roles
                let items: any = newMenu[j].items;
                for (let k = 0; k < items.length; k++) {
                    if (items[k]['status'] != undefined) {
                        //check if value exists in array of object or not
                        let valueExists = newAssignedRoles.some((el: any) => el.label == newMenu[j]['label']);
                        //if value exists in array of object the push in items array
                        if (valueExists) {
                            for (let x = 0; x < newAssignedRoles.length; x++) {
                                if (newAssignedRoles[x]['label'] == newMenu[j]['label']) {
                                    newAssignedRoles[x]['items']?.push(items[k]);
                                }
                            }
                        } else {
                            //if value does not exusts in array object then push new object in array
                            newAssignedRoles.push({
                                label: newMenu[j]['label'],
                                icon: newMenu[j]['icon'],
                                items: [items[k]]
                            });
                        }
                    }
                }
            } else {
                if (newMenu[j]['status'] != undefined) {
                    newAssignedRoles.push(newMenu[j]);
                }
            }
        }
        setAssignedActions(newAssignedRoles);
    };

    let menuClick: any;

    let topbarItemClick: any;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        topbarItemClick = false;
        menuClick = false;
    };

    const onMenuButtonClick = (event: any) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event: any) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event: any) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event: any) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event: any) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static'
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            <AppTopbar
                items={assignedActions}
                // menuMode={menuMode}
                // menuActive={menuActive}
                topbarMenuActive={topbarMenuActive}
                activeInlineProfile={activeInlineProfile}
                onTopbarItemClick={onTopbarItemClick}
                // onMenuButtonClick={onMenuButtonClick}
                // onSidebarMouseOver={onSidebarMouseOver}
                // onSidebarMouseLeave={onSidebarMouseLeave}
                // onToggleMenu={onToggleMenu}
                // onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                // onMenuClick={onMenuClick}
                // onMenuItemClick={onMenuItemClick}
                // onRootMenuItemClick={onRootMenuItemClick}
                // resetActiveIndex={resetActiveIndex}
            />

            <AppMenu
                model={menuWithAccess}
                onRootMenuItemClick={onRootMenuItemClick}
                onMenuItemClick={onMenuItemClick}
                onToggleMenu={onToggleMenu}
                onMenuClick={onMenuClick}
                menuMode={menuMode}
                menuActive={menuActive}
                sidebarActive={sidebarActive}
                sidebarStatic={sidebarStatic}
                pinActive={pinActive}
                onSidebarMouseLeave={onSidebarMouseLeave}
                onSidebarMouseOver={onSidebarMouseOver}
                activeInlineProfile={activeInlineProfile}
                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                resetActiveIndex={resetActiveIndex}
            />
            <div className="layout-main">
                <div className="layout-main-content">
                    <Routes>
                        <Route path="/dashboard" element={<Dashboard />} />

                        {/* User History */}
                        <Route path="/user-history" element={<UserHistory />} />

                        {/* College Management */}
                        <Route path="/app/college-management" element={<CollegeManagement />} />
                        <Route path="/app/pci-approval" element={<PciApproval />} />
                        <Route path="/app/pending-pci-approval-list" element={<PendingPciApprovalList />} />

                        <Route path="/app/admitted-list" element={<AdmittedList />} />
                        <Route path="/app/pending-admitted-list" element={<PendingAdmittedList />} />
                        <Route path="/app/view-admitted-details/:id" element={<AdmitDetails />} />

                        <Route path="/app/passout-list" element={<PassoutList />} />
                        <Route path="/app/pending-passout-list" element={<PendingPassoutList />} />
                        <Route path="/app/view-passout-details/:id" element={<PassoutDetail />} />

                        {/* Applications */}
                        <Route path="/app/application/fresh-registration-list" element={<FreshApplication />} />
                        <Route path="/app/application/fresh-registration-other-list" element={<FreshApplicationOther />} />
                        <Route path="/app/application/fresh-registration-transfer-list" element={<FreshApplicationTranferIn />} />
                        <Route path="/app/application/fresh-registration-transfer-list-diu-daman/:status" element={<FreshApplicationDamanAndDiu />} />
                        <Route path="/app/application/eliglible-application-list" element={<EligibleApplicationList />} />
                        <Route path="/app/application/eliglible-application-other-list" element={<EligibleApplicationOtherList />} />
                        <Route path="/app/application/renew-application" element={<RenewApplication />} />
                        <Route path="/app/application/re-entry" element={<ReEntryApplication />} />
                        <Route path="/app/application/electoral" element={<Electoral />} />
                        <Route path="/app/application/election-deposit" element={<ElectionDeposit />} />
                        <Route path="/app/application/nomination-fees-form" element={<NominationFormFees />} />
                        <Route path="/app/application/address-change" element={<AddressChange />} />
                        <Route path="/app/application/name-change" element={<NameChange />} />
                        <Route path="/app/application/goodstanding-application-list" element={<GoodStanding />} />
                        <Route path="/app/application/duplicate-certificate-application-list" element={<DuplicateCertificate />} />
                        <Route path="/app/application/degree-addition" element={<DegreeAddition />} />
                        <Route path="/app/application/pro-to-org-application" element={<ProToOrg />} />
                        <Route path="/app/application/search" element={<SearchByName />} />
                        <Route path="/app/application/registration-cancellation" element={<RegistrationCancellation />} />
                        <Route path="/app/application/permanent-cancelled-registration" element={<PermanentRegCancellation />} />
                        <Route path="/app/application/penlty" element={<Penalty />} />
                        <Route path="/app/application/penalty-jan-vishwas" element={<PenaltyJanVishwas />} />
                        <Route path="/app/application/applicationViewForm/:fileNo" element={<ApplicationViewForm />} />
                        <Route path="/app/application/eligibleForm/:fileNo" element={<EligibleViewForm />} />
                        <Route path="/app/application/viewDocument/:fileNo/:appName" element={<ViewDocument />} />
                        <Route path="/app/application/viewOtherAppDocument/:fileno/:appName/:rno/:status" element={<ViewOtherDocument />} />
                        <Route path="/app/application/viewEligibleDocument/:fileNo/:appName/:state" element={<ViewEligibleDocument />} />
                        <Route path="/app/verification-list/:fileNo" element={<VerificationList />} />

                        {/* Booked Appointments List */}
                        <Route path="/app/application/fresh-registration/booked-appointment-list" element={<ViewAllBookedAppointment />} />

                        {/* Refresher Course */}
                        <Route path="/app/refresher-course-list" element={<OnlineRefresherCourseList />} />
                        <Route path="/app/refresher-course-candidates/:courseId" element={<ViewRefresherCourseCandidates />} />
                        <Route path="/app/refresher-course-certification/:courseId" element={<ViewRefresherCourseCertification />} />
                        <Route path="/app/manage-refresher-course" element={<AddUpdateOnlineRefresherCourse />} />
                        <Route path="/app/manage-refresher-course/:courseId" element={<AddUpdateOnlineRefresherCourse />} />
                        <Route path="/app/offline-refresher-course-list" element={<OfflineRefresherCourseList />} />
                        <Route path="/app/offline-refresher-course-candidates/:courseId" element={<ViewOfflineRefresherCourseCandidates />} />
                        <Route path="/app/offline-refresher-course-certification/:courseId" element={<ViewOfflineRefresherCourseCertification />} />
                        <Route path="/app/offline-manage-refresher-course" element={<AddUpdateOfflineRefresherCourse />} />
                        <Route path="/app/offline-manage-refresher-course/:courseId" element={<AddUpdateOfflineRefresherCourse />} />

                        {/* Certification List */}
                        {/* Online Certification List */}
                        <Route path="/app/refresher-course-list-certification/:id" element={<ViewCertificationList />} />
                        {/* Offline Certification List */}
                        <Route path="/app/offline-refresher-course-list-certification/:id" element={<ViewOfflineCertificationList />} />

                        {/* User Management */}
                        <Route path="/app/user-management" element={<UserManagement />} />

                        {/* Book Appointment */}
                        <Route path="/app/book-appointment" element={<BookAppointments />} />
                        <Route path="/app/appointment-list" element={<AppointmentList />} />
                        <Route path="/app/user-appointment-list/:SlotId" element={<UserAppointmentList />} />

                        {/* Account */}
                        <Route path="/app/account/bank-entry" element={<BankEntry />} />
                        <Route path="/app/account/add-bank-entry" element={<AddBankEntry />} />
                        <Route path="/app/account/cash-entry" element={<CashEntry />} />
                        <Route path="/app/account/add-cash-entry" element={<AddCashEntry />} />
                        <Route path="/app/account/jv-entry-list" element={<JVEntry />} />
                        <Route path="/app/account/add-jv-entry" element={<AddJVEntry />} />

                        {/* Master */}
                        <Route path="/app/account-master" element={<AccountMaster />} />
                        <Route path="/app/account-group" element={<AccountGroup />} />
                        <Route path="/app/application-bill-master" element={<ApplicationBillMaster />} />
                        <Route path="/app/application-master" element={<ApplicationMaster />} />
                        <Route path="/app/document-master" element={<DocumentMaster />} />
                        <Route path="/app/add-document" element={<AddDocument />} />
                        <Route path="/app/board-master" element={<BoardMaster />} />
                        <Route path="/app/approval" element={<ApprovalMasterList />} />
                        <Route path="/app/add-approval" element={<AddApprovalMasetr />} />
                        <Route path="/app/college-entry" element={<CollegeEntry />} />
                        <Route path="/app/college-entry-list" element={<AllCollegesList />} />
                        <Route path="/app/council-master" element={<CouncilMaster />} />
                        <Route path="/app/exam-authority" element={<ExamAuthority />} />
                        <Route path="/app/hospital-master" element={<HospitalMaster />} />
                        <Route path="/app/hospital-list" element={<AllHospitalList />} />
                        <Route path="/app/other-master" element={<OtherMaster />} />
                        <Route path="/app/university-master" element={<UniversityMaster />} />
                        <Route path="/app/user-update" element={<UserUpdate />} />

                        {/* Letter */}
                        <Route path="/app/letters/ruhs-letter" element={<RHUSLetter />} />
                        <Route path="/app/letters/nios-letter" element={<NIOSLetter />} />
                        <Route path="/app/letters/verification-university" element={<UniversityLetter />} />
                        <Route path="/app/letters/verification-board" element={<BoardLetter />} />
                        <Route path="/app/letters/verification-college" element={<CollegeLetter />} />
                        <Route path="/app/letters/verification-school" element={<SchoolLetter />} />
                        <Route path="/app/letters/gujarat-other-councils" element={<GujaratOtherCouncils />} />
                        <Route path="/app/letters/register-cancellation" element={<RegistrationCancellationLetter />} />
                        <Route path="/app/letters/application-cancellation" element={<ApplicationCancellationLetter />} />
                        <Route path="/app/letters/warning-letter" element={<WarningLetter />} />
                        <Route path="/app/letters/submission-letter" element={<SubmissionLetter />} />
                        <Route path="/app/letters/false-and-fake" element={<FalseAndFakeLetter />} />
                        <Route path="/app/letters/wrong-affidavit-letter" element={<WrongAffidavitLetter />} />
                        <Route path="/app/letters/reminder-college-letter" element={<ReminderToCollege />} />
                        <Route path="/app/letters/reminder-school-letter" element={<ReminderToSchool />} />
                        <Route path="/app/letters/reminder-council" element={<ReminderToCouncil />} />
                        <Route path="/app/letters/reminder-hospital" element={<ReminderToHospital />} />
                        <Route path="/app/letters/reminder-medical" element={<ReminderToMedical />} />
                        <Route path="/app/letters/reminder-university" element={<ReminderToUniversity />} />
                        <Route path="/app/letters/reminder-board" element={<ReminderToBoard />} />
                        <Route path="/app/letters/reminder-nios" element={<ReminderToNIOS />} />
                        <Route path="/app/letters/reminder-ruhs" element={<ReminderToRUHS />} />
                        <Route path="/app/letters/noc-letter" element={<NOCLetter />} />
                        <Route path="/app/letters/transferin" element={<TransferInLetter />} />
                        <Route path="/app/letters/practical-training" element={<PracticalTraining />} />

                        <Route path="/app/letters/data-flow" element={<DataFlow />} />

                        {/* Scrutiny */}
                        <Route path={`/app/scrutiny/verificationList/:fileno`} element={<ScrutinyVerificationList />} />
                        <Route path={`/app/scrutiny/viewDocument/:fileno/:appName`} element={<ViewScrutinyDocument />} />
                        <Route path={`/app/scrutiny/viewOtherDocument/:fileNo/:appName/:rNo`} element={<ViewOtherScrutinyDocument />} />
                        {/* Fresh Reg Scrutiny */}
                        <Route path={`/app/scrutiny/fresh-registration-scrutiny/:status`} element={<FreshRegistrationScrutiny />} />
                        <Route path={`/app/scrutiny/fresh-registration-scrutiny/:status/:fileNo`} element={<FreshRegistrationScrutinySteps />} />

                        {/* Other State Scrutiny */}
                        <Route path={`/app/scrutiny/other-state-scrutiny/:status`} element={<OtherStateScrutiny />} />
                        <Route path={`/app/scrutiny/other-state-scrutiny/:status/:fileNo`} element={<OtherStateScrutinySteps />} />

                        {/* Transfer To Gujarat Scrutiny */}
                        <Route path={`/app/scrutiny/transfer-to-gujarat-scrutiny/:status`} element={<TransferToGujaratScrutiny />} />
                        <Route path={`/app/scrutiny/transfer-to-gujarat-scrutiny/:status/:fileNo`} element={<TrasnferToGujaratScrutinySteps />} />

                        {/* Transfer To DD/DHN Scrutiny */}
                        <Route path={`/app/scrutiny/transfer-to-dd-dnh-scrutiny/:status`} element={<TransferToDDDNHScrutiny />} />
                        <Route path={`/app/scrutiny/transfer-to-dd-dnh-scrutiny/:status/:fileNo`} element={<TrasnferToDDDNHScrutinySteps />} />

                        {/* degree Addition Scrutiny */}
                        <Route path={`/app/scrutiny/degree-addition-scrutiny/:status`} element={<DegreeAdditionScrutiny />} />
                        <Route path={`/app/scrutiny/degree-addition-scrutiny/:fileNo/:rNo/:status`} element={<DegreeAdditionScrutinySteps />} />

                        {/* Re-Entry Scrutiny */}
                        <Route path={`/app/scrutiny/re-entry-scrutiny/:status`} element={<ReEntryScrutiny />} />
                        <Route path={`/app/scrutiny/re-entry-scrutiny/:fileNo/:rNo/:status`} element={<ReEntryScrutinySteps />} />

                        {/* Reports */}
                        <Route path="/app/reports" element={<Reports />} />

                        <Route path="/app/report/application-register" element={<ApplicationRegisterReport />} />
                        <Route path="/app/report/fresh-application-register" element={<FreshApplicationRegisterReport />} />
                        <Route path="/app/report/fee-register" element={<FeeRegisterReport />} />
                        <Route path="/app/report/degree-detail" element={<DegreeDetails />} />
                        <Route path="/app/report/g-number-wise-detail" element={<GNumberWiseReport />} />
                        <Route path="/app/report/receipt-download" element={<ReceiptDownload />} />
                        <Route path="/app/report/registration-validation" element={<RegistrationValidation />} />
                        <Route path="/app/report/application-detail" element={<ApplicationDetail />} />
                        <Route path="/app/report/registration-cancellation" element={<RegistrationCancellations />} />
                        <Route path="/app/report/dd-report" element={<DDRegisterReport />} />
                        <Route path="/app/report/provisional-original-report" element={<ProvOrgCertificateReport />} />
                        <Route path="/app/report/collegewise-registration" element={<CollegeWiseRegisterReport />} />
                        <Route path="/app/report/government-report" element={<GovernmentReport />} />
                        <Route path="/app/report/pci-register" element={<PCIRegisterReport />} />
                        <Route path="/app/report/record-register" element={<RecordRegisterReport />} />
                        <Route path="/app/report/electrol-register" element={<ElectrolRegisterReport />} />
                        <Route path="/app/report/statistics-validation" element={<StaticsReport />} />
                        <Route path="/app/report/inout-register-report" element={<InOutRegisterReport />} />

                        {/* Financial Reports */}
                        <Route path="/app/financial-reports" element={<FinancialReports />} />
                        <Route path="/app/report/financial/account-ledger" element={<AccountLedgerReport />} />
                        <Route path="/app/report/financial/cashbook-detail" element={<CashBookDetailsReport />} />
                        <Route path="/app/report/financial/bankbook-detail" element={<BankBookDetailReport />} />
                        <Route path="/app/report/financial/jvbook-detail" element={<JvBookDetailsReport />} />
                        <Route path="/app/report/financial/trial-balance" element={<TrialBalanceReport />} />
                        <Route path="/app/report/financial/profit-and-lose-account" element={<ProfitLossReport />} />

                        {/* Front Websites */}
                        <Route path="/app/banner-image" element={<Banner />} />
                        <Route path="/app/latest-update" element={<LatestUpdate />} />
                        <Route path="/app/notice" element={<Notice />} />
                        <Route path="/app/refresher-course" element={<RefresherCourse />} />
                        <Route path="/app/inquiry" element={<Inquiry />} />
                        <Route path="/app/gallery" element={<Gallary />} />

                        {/* Billing */}
                        <Route path="/app/billing/billing" element={<Billing />} />

                        {/* Certificates */}
                        <Route path="/app/certificate/provisional-certificate" element={<ProvisionalCertificate />} />
                        <Route path="/app/certificate/provisional-certificate-list" element={<ProvisionalCertificateList />} />
                        <Route path="/app/certificate/original-certificate" element={<OriginalCertificate />} />
                        <Route path="/app/certificate/original-certificate-list" element={<OriginalCertificateList />} />
                        <Route path="/app/certificate/remaining-original-certificate-list" element={<RemainingOriginalCertificateList />} />
                        <Route path="/app/certificate/duplicate-certificate" element={<DuplicateCertificateList />} />
                        <Route path="/app/certificate/additional-certificate" element={<AdditionalCertificate />} />
                        <Route path="/app/certificate/goodstanding-certificate" element={<GoodStandingCertificate />} />
                        <Route path="/app/certificate/goodstanding-certificate-list" element={<GoodStandingCertificateList />} />
                        <Route path="/app/certificate/registration-date-update" element={<RegistrationDateUpdate />} />

                        {/* In-Out Register */}
                        <Route path="/app/in-out/add-inward-registration" element={<InwardRegister />} />
                        <Route path="/app/in-out/inward-registration-list" element={<InwardRegisterList />} />
                        <Route path="/app/in-out/add-outward-registration" element={<OutwardRegister />} />
                        <Route path="/app/in-out/outward-registration-list" element={<OutwardRegisterList />} />

                        {/* Job Portal */}
                        <Route path="/app/job-portal/department-list" element={<DepartmentList />} />
                        <Route path="/app/job-portal/student-list" element={<StudentList />} />
                        <Route path="/app/job-portal/job-list" element={<JobList />} />

                        {/* Role Management */}
                        <Route path="/app/permission/role-management" element={<RoleManagement />} />
                        <Route path="/app/permission/add-role" element={<AddRole />} />
                        <Route path="/app/permission/user-management" element={<UserWiseMenu />} />
                    </Routes>
                </div>

                <AppFooter />
                {/* {dyamicUrl.length > 0 ? '' : <Loader />} */}
            </div>
        </div>
    );
};

export default App;
